<template>
  <router-view v-model="interestZone" />
</template>

<script lang="ts" setup>
import { useRoute } from 'vue-router';
import { useFetchQuery } from '@hooks/fetch';
import { syncPageBusy } from '@utils/busy/injects';
import { computed, watch } from 'vue';
import { syncHeader } from '@components/structure/navigation/injects';
import { useI18n } from 'vue-i18n';
import type { InterestZone } from '@/entities/Entities';

const route = useRoute();
const { t } = useI18n();

const { data: interestZone, loading } = useFetchQuery<InterestZone>(
  `/interest_areas/${route.params.interestZoneId}`,
);

syncPageBusy(loading);

const title = computed(() => interestZone.value?.name ?? '');
const longTitle = computed(() => {
  const type = t(`interestZone.type.${interestZone.value?.type}`);
  return `${title.value} (${type})`;
});

syncHeader(interestZone, () => ({
  extraBreadcrumbs: [
    computed(() => ({
      label: title.value,
      link: {
        name: 'interest-zone-details',
        params: { interestZoneId: interestZone.value?.id ?? '-' },
      },
    })),
  ],
  title: computed(() => ({
    text: longTitle.value,
    link: { name: 'interest-zones' },
  })),
}));
</script>

<style lang="scss" scoped></style>
